import { render, staticRenderFns } from "./CorporateForm.vue?vue&type=template&id=3d494457&scoped=true&"
import script from "./CorporateForm.vue?vue&type=script&lang=js&"
export * from "./CorporateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d494457",
  null
  
)

export default component.exports